import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { Loader2 } from 'lucide-react';

export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get session to check for success
        const { data, error } = await supabase.auth.getSession();
        
        if (error) throw error;
        
        if (data.session) {
          const userId = data.session.user.id;
          const isEmailVerified = !!data.session.user.email_confirmed_at;
          
          // Check for user profile 
          let { data: userData, error: profileError } = await supabase
            .from('users')
            .select('organization_id, name, first_name, last_name')
            .eq('user_id', userId)
            .maybeSingle();

          if (profileError) throw profileError;

          // If not verified, send to verification page
          if (!isEmailVerified) {
            navigate('/auth/verify-email');
          } 
          // If verified and has organization, go to dashboard
          else if (userData?.organization_id) {
            navigate('/dashboard');
          } 
          // If verified but no organization (unusual edge case), go to registration
          else {
            navigate('/auth/register');
          }
        } else {
          // If no session, redirect to login
          navigate('/auth/login');
        }
      } catch (error: any) {
        console.error('Error during auth callback:', error);
        setError(error.message);
        setTimeout(() => {
          navigate('/auth/login');
        }, 3000);
      }
    };
    
    handleCallback();
  }, [navigate]);
  
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[70vh]">
        <p className="text-destructive mb-4">Authentication error: {error}</p>
        <button 
          className="text-primary hover:underline" 
          onClick={() => navigate('/auth/login')}
        >
          Back to login
        </button>
      </div>
    );
  }
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh]">
      <Loader2 className="h-10 w-10 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">Completing authentication...</p>
    </div>
  );
}